import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebase.js";

const db = getFirestore(firebaseApp);

export const getMembershipFromUsers = async (uid) => {
  if (!uid) return [];

  try {
    const membershipRef = collection(db, "Users", uid, "membership");
    const membershipSnap = await getDocs(membershipRef);

    if (membershipSnap.empty) return [];

    const memberships = await Promise.all(
      membershipSnap.docs.map(async (docSnap) => {
        const data = docSnap.data();

        if (data.subSGloopReference) {
          try {
            const subSGloopSnap = await getDoc(data.subSGloopReference);
            if (subSGloopSnap.exists()) {
              data.subSGloopData = {
                id: subSGloopSnap.id,
                ...subSGloopSnap.data(),
              };
            }
          } catch (err) {
            console.error(
              `Error fetching subSGloopReference for ${docSnap.id}:`,
              err
            );
          }
        }

        return {
          id: docSnap.id,
          ...data,
        };
      })
    );

    return memberships;
  } catch (error) {
    console.error("Error fetching memberships:", error);
    return [];
  }
};

